import {Fields} from '@vuex-orm/core';
import {RawTaskType} from '@/tasks/types/RawTaskType';
import {StembleModel} from '@/common/models/StembleModel';

/**
 *  @deprecated  In favor of task-input types *
 * TaskTopic class
 */
export class TaskType extends StembleModel implements RawTaskType {
  static entity = 'TaskType';

  id!: number;
  description!: string;

  static fields(): Fields {
    return {
      id: this.number(null),
      description: this.string(null),
    };
  }
}

export default TaskType;
